import { useEffect, useState } from 'react';
import CashbackIcon from './CashbackIcon';

const SplashScreen = ({ onFinish }: { onFinish: () => void }) => {
  const [dots, setDots] = useState(0);

  useEffect(() => {
    // Loading dots animation
    const dotsInterval = setInterval(() => {
      setDots((prev) => (prev + 1) % 4);
    }, 500);

    // Show splash for at least 1.5 seconds
    const finishTimer = setTimeout(() => {
      onFinish();
    }, 1500);

    return () => {
      clearInterval(dotsInterval);
      clearTimeout(finishTimer);
    };
  }, [onFinish]);

  return (
    <div className="fixed inset-0 bg-[#0a0a0a] flex flex-col items-center justify-center z-[9999]">
      <div className="flex flex-col items-center gap-8">
        {/* Logo with loading dots animation */}
        <div className="relative w-32 h-32 flex items-center justify-center">
          <CashbackIcon size={128} className="text-primary" />
        </div>

        {/* Tagline */}
        <div className="text-center">
          <h1 className="text-2xl font-bold text-white mb-3">CashbackHub</h1>
          <p className="text-tg-hint text-sm">
            Loading{'.'.repeat(dots)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;

